export const isNotEmpty = (value) => value && value.trim() !== '';
export const isEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const isInArray = (value, array) => array.includes(value);
export const isValidDateRange = (startDate, endDate) => startDate && endDate && new Date(startDate) <= new Date(endDate);
